<div class="CeParameterItem-content">
    <span class="CeParameterItem-primary">
        <span class="CeParameterItem-descriptionWrap" [ngClass]="{ 'CeParameterItem-truncate': truncated }">
            <ng-content></ng-content>
            <ng-content select="[ceParameterItemValue]"></ng-content>
        </span>
    </span>
    <span class="CeParameterItem-secondary">
        <div [ngClass]="{ 'CeParameterItem-secondary--truncate': truncated }">
            <ng-content select="[ceParameterItemSecondary]"></ng-content>
        </div>
    </span>
</div>
